<template>
    <component
            :is="component"
            :props="props"
    ></component>
</template>

<script>
export default {
    name: "VueDynamicComponent",
    props: {
        props: {
            default: function () {
                return { }
            }
        },
        path: String,
    },
    computed: {
        component() {
            return () => import(`./../../${this.path}.vue`);
        }
    }
}
</script>

<style scoped>

</style>